import React from "react";

import { Wrapper, SkeletonCard } from "./AdminAreaSkeleton.styles";

const AdminAreaSkeleton: React.FC = () => (
  <>
    {Array.from({ length: 5 }).map((_, i) => (
      <Wrapper key={i}>
        <SkeletonCard
          variant="rectangular"
          animation="wave"
          height={72}
          sx={{ bgcolor: "#DEE3E8" }}
        />
      </Wrapper>
    ))}
  </>
);

export default AdminAreaSkeleton;
